module.exports = __webpack_public_path__ + "static/media/ageelementfirmingconcentrate.f466f346.png";